import { api } from '@/shared/api/axios';
import { unwrapList, unwrapSingle, unwrapPage } from '@/shared/api/unwrap';

const base = (depId) => `/deployments/${depId}/alerts`;

export const alertsApi = {
  live: (depId) => api.get(`${base(depId)}/live`).then(unwrapList),

  // Paginated: params = { from, to, page, pageSize }. Returns { rows, pagination }.
  historical: (depId, params = {}) =>
    api.get(`${base(depId)}/historical`, { params }).then(unwrapPage),

  detail: (depId, alertId) =>
    api.get(`${base(depId)}/${alertId}`).then(unwrapSingle),

  // Filter schema for the history table: { fields, sortable }.
  filters: (depId) => api.get(`${base(depId)}/filters`).then(unwrapSingle),
};
